import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { MingaPermission } from 'libs/domain';

import { PermissionsService } from '@app/src/app/permissions';

import { MingaManagerRoutes } from '../constants';

@Injectable()
export class MingaManagerRedirectGuard {
  constructor(private _router: Router, private _permissionsService: PermissionsService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const hasFullAccess = this._permissionsService.hasPermission(MingaPermission.MINGA_ACCOUNT_MANAGE);

    if (!hasFullAccess) {
      // Redirect to subscription page
      this._router.navigate([MingaManagerRoutes.ROOT, MingaManagerRoutes.SUBSCRIPTION]);
    }

    return hasFullAccess;
  }
}
